// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_znS","rootNoMargin":"styles_rootNoMargin___bhLz"};